export default "__VITE_ASSET__fa7c77e1__"